/* eslint-disable max-len */
import React,{useState} from 'react'
import ThreeDotsLoader from '../../Components/LoadingDots'
import { CamelCase } from '../../redux/helper/CamelCase';
import DeleteModal from './DeleteModal';

export default function CrudModal({type,handleCreate,setmodalType,selectedWishlist,handleRemoveModal,handleCrud,selectedProduct,removeAll,removeParticular}) {
    const [name, setname] = useState(type==='create'?'':selectedWishlist.collection_name);
    const [loading, setloading] = useState(false);
    const deleteTypes=['delete','remove','removeAll']
    const handleTitle=()=>{
        let title=''
        if(type==='remove' ||  type==='removeAll'){
            title='Remove products from wishlist';
        }else{
            title=`${CamelCase(type)} Wishlist`

        }
        return title
    }
    return (
        <div className="modal fade fixed top-0 left-0 show w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="editWishlist" tabIndex="-1" aria-labelledby="exampleModalCenterTitle" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative sm:max-w-[398px] w-full px-3 pointer-events-none mx-auto" style={{margin: 'auto'}}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="sm:text-xl text-base font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            <>{handleTitle()}</>
                        </h5>
                        <button type="button"
                            onClick={()=>setmodalType('')}
                            className="btn-close1 box-content sm:w-4 sm:h-4 w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-[4px] sm:right-1 top- right-4"
                            data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <>{deleteTypes.includes(type) ? <>
                        <DeleteModal
                            setmodalType={setmodalType}
                            type={type}
                            loading={loading}
                            setloading={setloading}
                            selectedWishlist={selectedWishlist}
                            handleRemoveModal={handleRemoveModal}
                            selectedProduct={selectedProduct}
                            name={name}
                            handleCrud={handleCrud}
                            removeAll={removeAll}
                            removeParticular={removeParticular}
                        />
                    </>
                        :<>
                            <div>
                                <div className="modal-body relative sm:px-8 px-3 sm:pt-7 pt-5">
                                    <input type="text"
                                        value={name}
                                        onChange={(e)=>setname(e.target.value)}
                                        className="bg-[#FFFFFF] border-[#E9E9E9] border sm:px-[18px] px-3 py-3 rounded-lg w-full outline-0 sm:text-base text-sm font-normal text-[#090406] placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter New Wishlist Name" />
                                </div>
                                <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center pt-6 pb-[18px] border-gray-200 rounded-b-md">
                                    <button 
                                        onClick={()=>{
                                            setloading(true)
                                            handleCreate(name,type);
                                            setTimeout(() => {
                                                setmodalType('')
                                                setloading(false)
                                            }, 2000);
                                        }}
                                        type="button" 
                                        disabled={name.length===0} className="inline-block w-fit px-8 py-2 bg-[#555259] text-white sm:text-base text-sm font-semibold leading-tight rounded-lg transition duration-150 ease-in-out update-wishlist"
                                        data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#editWishlist">
                                        <>{loading?<ThreeDotsLoader/>:<>{CamelCase(type)} Wishlist</>}</>
                                    </button>
                                </div>
                            </div> 
                        </>
                          
                    }
                    </>
                </div>
            </div>
        </div>
    )
}
